import Head from 'next/head';

function generateSeznamRetargetingScript(retargetingId: string) {
  return `
  (function (d) {
    var s = d.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = 'https://c.seznam.cz/js/rc.js';
    s.onload = function () {
      if (window.sznIVA && window.sznIVA.IS) {
        window.sznIVA.IS.updateIdentities({ eid: null });
      }
      if (window.rc) {
        window.rc.retargetingHit({ rtgId: ${retargetingId}, consent: null });
      }
    };
    d.getElementsByTagName('head')[0].appendChild(s);
  })(document);`;
}

const SeznamRetargeting: React.FC<{ readonly retargetingId: string }> = ({
  retargetingId,
}) => {
  return (
    <Head>
      <script
        key="seznam-retargeting"
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: generateSeznamRetargetingScript(retargetingId),
        }}
      ></script>
    </Head>
  );
};

export default SeznamRetargeting;
